<template>
  <div id="pdf-template-images-table">
    <span style="font-size:24px;bold">{{$t('pdf_template_texts_table.images')}}</span>
    <table cellpadding="0" cellspacing="0">
      <tr class="header-row" v-if="template.images.length > 0">
        <td
          v-for="(header, i) in headers"
          :key="i"
          :style="{ 'width': header.width + '%'}"
        >{{header.text}}</td>
      </tr>
      <tr v-for="(image, i) in template.images" :key="i">
        <td>
          <input v-model="image.x1" type="number" @keydown="joystick($event, image, ['x1', 'y1'])" />
        </td>
        <td>
          <input v-model="image.y1" type="number" @keydown="joystick($event, image, ['x1', 'y1'])" />
        </td>
        <td>
          <input
            v-model="image.width"
            type="number"
            @keydown="joystick($event, image, ['width', 'height'])"
          />
        </td>
        <td>
          <input
            v-model="image.height"
            type="number"
            @keydown="joystick($event, image, ['width', 'height'])"
          />
        </td>
        <td>
          <input v-model="image.image_name" type="text" />
        </td>
        <td>
          <v-icon
            v-if="image.attachment.id != null"
            @click="downloadAttachment(image.attachment)"
          >attachment</v-icon>
        </td>
        <td>
          <input
            type="file"
            ref="files"
            class="form-control-file"
            id="file-input"
            accept="image/jpg, image/jpeg"
            @change="handleFilesUpload(image, i)"
          />
        </td>
        <td>
          <v-icon small @click="deleteImage(i)">delete</v-icon>
        </td>
      </tr>
    </table>
    <button
      type="submit"
      class="btn btn-primary"
      @click="addImage"
    >{{$t('pdf_template_texts_table.add_image')}}</button>
  </div>
</template>

<script>
import PdfTemplateImage from "@/models/PdfTemplateImage.js";
import Helper from "@/models/Helper.js";
export default {
  name: "pdf-template-images-table",
  props: {
    template: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: "X",
          width: 5,
        },
        {
          text: "Y",
          width: 5,
        },
        {
          text: this.$t("pdf_template_texts_table.width"),
          width: 5,
        },
        {
          text: this.$t("pdf_template_texts_table.height"),
          width: 5,
        },
        {
          text: this.$t("pdf_template_texts_table.name"),
          width: 30,
        },
        {
          text: this.$t("pdf_template_texts_table.file"),
          width: 20,
        },
        {
          text: this.$t("pdf_template_texts_table.select_file"),
          width: 20,
        },

        {
          text: this.$t("pdf_template_texts_table.actions"),
          with: 10,
        },
      ],
      defaultimage: {
        x1: 0,
        y1: 0,
        width: 50,
        height: 50,
      },
    };
  },
  methods: {
    addImage() {
      this.template.images.push(new PdfTemplateImage(this.defaultimage));
    },
    deleteImage(i) {
      this.template.images.splice(i, 1);
    },
    handleFilesUpload(image, i) {
      this.files = this.$refs.files[i].files;
      if (this.files) {
        image.file = this.files[0];
      }
    },
    downloadAttachment(attachment) {
      window.open(attachment.location, "_blank");
    },
    joystick(e, box, props) {
      Helper.joystick(e, box, props);
    },
  },
};
</script>

<style scoped>
input {
  border: 0px solid #000;
  margin: 0;
  background: transparent;
  width: 100%;
}
table tr td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
}
table {
  background: #fff none repeat scroll 0 0;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
}
table tr:nth-child(even) {
  background: #ccc;
}
table tr:nth-child(odd) {
  background: #eee;
}
.header-row {
  font-weight: bold;
}
</style>